<div class="pv-input">
	@if (label) {
		<ic-label [help]="help" [required]="required"> {{ label }} </ic-label>
	}
	<div class="border" [formGroup]="form">
		@if (icon) {
			<i aria-hidden="true" [class]="icon" [class.disabled]="disabled"> </i>
		}
		<input
			data-test="hours-input"
			formControlName="hour"
			maxlength="2"
			pattern="[0-9]{2}"
			placeholder=".."
			type="text"
			(blur)="onBlur('hour')"
			(keydown.tab)="onTab('hour')"
		/>
		<span> &#58; </span>
		<input
			#minutesInput
			data-test="minutes-input"
			formControlName="minutes"
			maxlength="2"
			pattern="[0-9]{2}"
			placeholder=".."
			type="text"
			(blur)="onBlur('minutes')"
			(keydown.tab)="onTab('minutes')"
		/>
	</div>
	<ng-content select=".errors" />
</div>
